import { render, staticRenderFns } from "./AddProductToCartModalManager.vue?vue&type=template&id=455b4928"
import script from "./AddProductToCartModalManager.vue?vue&type=script&lang=js"
export * from "./AddProductToCartModalManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports